import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
// import utils from './utils';
import PowerBI from './PowerBI';
import NavPanel from './navigation/NavPanel';
import AppLayout from '../shared/AppLayout';
import PageSpecificHeader from '../shared/PageSpecificHeader';

const Container = styled(Box)({
  display: 'flex',
  height: '70vh',
});

export default function Reports(): JSX.Element {
  return (
    <AppLayout>
      <PageSpecificHeader title="Reports" description="View filtered reports" />
      <Container>
        <NavPanel />
        <PowerBI />
      </Container>
    </AppLayout>
  );
}
